export function reduceArcade(state, action) {
  switch (action.type) {
    case "OPEN_CUSTOM":
      return { ...state, view: "config" };
    case "START_PENDING":
      return {
        ...state,
        view: "starting",
        resumeView: state.view === "starting" ? state.resumeView : state.view,
        gameMode: action.gameMode ?? state.gameMode,
        questionCount: action.questionCount ?? state.questionCount,
      };
    case "START_FAILED":
      return {
        ...state,
        view: state.resumeView || "hub",
        phase: "idle",
        resumeView: null,
      };
    case "START_SUCCESS":
      return {
        ...state,
        view: "playing",
        phase: "answering",
        resumeView: null,
        gameMode: action.gameMode,
        questionCount: action.questionCount,
        currentQuestionIndex: 0,
        selectedAnswer: null,
        lastResult: null,
        bestStreakThisGame: 0,
        toastQueue: [],
        results: null,
        startLevel: action.startLevel,
        startXp: action.startXp,
        lastCustomConfig: action.customConfig || null,
      };
    case "ANSWER_LOCK":
      return {
        ...state,
        phase: "feedback",
        selectedAnswer: action.answer,
      };
    case "ANSWER_RESULT":
      return {
        ...state,
        lastResult: action.result,
        displayScore: action.result.currentScore ?? state.displayScore,
        displayStreak: action.result.streak ?? state.displayStreak,
        bestStreakThisGame: Math.max(
          state.bestStreakThisGame,
          action.result.streak || 0
        ),
        toastQueue: [
          ...state.toastQueue,
          ...(action.result.achievementsUnlocked || []),
        ],
      };
    case "FEEDBACK_DONE":
      if (state.lastResult?.nextQuestion != null) {
        return {
          ...state,
          phase: "answering",
          currentQuestionIndex: state.lastResult.nextQuestion,
          selectedAnswer: null,
          lastResult: null,
        };
      }
      return { ...state, phase: "complete" };
    case "COMPLETE_SUCCESS":
      return {
        ...state,
        view: "results",
        phase: "complete",
        results: action.results,
      };
    case "RETURN_HUB":
      return {
        view: "hub",
        phase: "idle",
        resumeView: null,
        gameMode: null,
        currentQuestionIndex: 0,
        questionCount: 0,
        selectedAnswer: null,
        lastResult: null,
        displayScore: 0,
        displayStreak: 0,
        bestStreakThisGame: 0,
        toastQueue: [],
        results: null,
        startLevel: 1,
        startXp: 0,
        lastCustomConfig: null,
        communityTab: state.communityTab || "leaderboards",
      };
    case "SET_COMMUNITY_TAB":
      return { ...state, communityTab: action.tab };
    case "DISMISS_TOAST":
      return { ...state, toastQueue: state.toastQueue.slice(1) };
    default:
      return state;
  }
}

export const initialArcadeState = {
  view: "hub",
  phase: "idle",
  resumeView: null,
  gameMode: null,
  currentQuestionIndex: 0,
  questionCount: 0,
  selectedAnswer: null,
  lastResult: null,
  displayScore: 0,
  displayStreak: 0,
  bestStreakThisGame: 0,
  toastQueue: [],
  results: null,
  startLevel: 1,
  startXp: 0,
  lastCustomConfig: null,
  communityTab: "leaderboards",
};
